import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User, UserType, AppRole} from '../../../models/user.model';
import { LookupService } from '../../../services/lookups/lookup.service';
import { RegistrationService } from '../../../services/registration.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  @Input() users: User[];
  @Input() userStatus: string;
  @Output() activateUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() deactivateUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() reload: EventEmitter<boolean> = new EventEmitter<boolean>();
        
  
  displayEditUserRoleDlg = false;
  userType: UserType;
  userRole: AppRole;
  userTypes: UserType[];
  appRoles: AppRole[];
  disableButton = true;
  disableSelection = true;
  userId: number;
  user: User;

  constructor(
    private registrationService: RegistrationService,
    private lookupService: LookupService,
    private _notifier: NotifierService
  ) { }

  ngOnInit() {
  }

  onActivateUser(user) {
    this.activateUser.emit(user);
  }

  onDeactivateUser(user) {
    this.deactivateUser.emit(user);
  }


  onEditUserRole(user) {
    //TODO
    //Should admin have capability to edit a user's user type and/or roles?
    this.userId = user.id;
    // console.log("USer Details === " + JSON.stringify(user))
    // User Types -- Post or HQ
    this.lookupService.getUserTypes().subscribe((data: UserType[]) => {
      this.userTypes = data;
      this.userTypes = this.userTypes.filter(type => type.typeName !== 'Unknown');
    });
    this.displayEditUserRoleDlg = true;
    this.disableButton = true;
    this.disableSelection = true;
  }

  onChangeUserType(userType, user) {
     this.disableButton = true;
     this.disableSelection = false;
    this.lookupService.getAppRolesByUserTypeId(this.userType.id).subscribe((data: AppRole[]) => {
      this.appRoles = data;
    });
  }

  onChangeUserRole()
  {
    this.disableSelection = false;
    this.disableButton = false;
  }

  saveChanges(user)
  {
    this.registrationService.editUserTypeAndRole(this.userId,this.userType.id,this.userRole.id).subscribe(resp => {
      if (resp.ok) {
        // this.onStatusSelection();
        this.displayEditUserRoleDlg = false;
        this._notifier.notify('success', 'User role edited successfully.');
        this.reload.emit(true);
      }
    });

  }
 
  closeDialog()
  {
      this.displayEditUserRoleDlg = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/user-management/users-list/users-list.component.ts